import { Field, inputCls } from "./ui";
import { slugify } from "../../utils/formBuilder";

// Right column: selected field settings (Bootstrap)
export default function Inspector({ field, updateField }) {
  if (!field) {
    return (
      <p className="text-center text-secondary small py-4">
        Select a field to edit its settings.
      </p>
    );
  }
  const numeric = ["text", "textarea", "number"].includes(field.type);

  return (
    <div>
      <Field label="Label (customer sees this)">
        <input
          className={inputCls}
          value={field.label}
          onChange={(e) => {
            const label = e.target.value;
            const auto = slugify(field.label) === field.key;
            updateField(
              field.id,
              auto ? { label, key: slugify(label) } : { label },
            );
          }}
        />
      </Field>

      <Field label="Key (data field name)">
        <input
          className={inputCls + " fb-mono"}
          value={field.key}
          onChange={(e) => updateField(field.id, { key: e.target.value })}
        />
      </Field>

      <div className="form-check my-2">
        <input
          className="form-check-input"
          type="checkbox"
          id={`req-${field.id}`}
          checked={field.required}
          onChange={(e) =>
            updateField(field.id, { required: e.target.checked })
          }
        />
        <label className="form-check-label small" htmlFor={`req-${field.id}`}>
          Required
        </label>
      </div>

      {field.type === "select" && (
        <Field label="Options (one per line)">
          <textarea
            rows={4}
            className={inputCls}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            value={(field.options || []).join("\n")}
            onChange={(e) =>
              updateField(field.id, {
                options: e.target.value.split("\n"),
              })
            }
          />
        </Field>
      )}

      {numeric && (
        <div className="d-flex gap-2">
          <Field label="Min">
            <input
              type="number"
              className={inputCls}
              value={field.min ?? ""}
              onChange={(e) =>
                updateField(field.id, {
                  min: e.target.value === "" ? null : +e.target.value,
                })
              }
            />
          </Field>
          <Field label="Max">
            <input
              type="number"
              className={inputCls}
              value={field.max ?? ""}
              onChange={(e) =>
                updateField(field.id, {
                  max: e.target.value === "" ? null : +e.target.value,
                })
              }
            />
          </Field>
        </div>
      )}

      {field.type === "image_multi" && (
        <Field label="Max images">
          <input
            type="number"
            className={inputCls}
            value={field.maxItems ?? 4}
            onChange={(e) =>
              updateField(field.id, { maxItems: +e.target.value || 1 })
            }
          />
        </Field>
      )}
    </div>
  );
}
